import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import { removeCreativeForPublish, selectCreativeForPublish, setAdformCredentialAsked, setAdformPublishSettings, setPublishLoader, setSelectedCreativesPublish, setSelectedPublishType, setWhereToPublish } from '../../../../slices/publish/reducer';
import AdformSettings from './AdformSettings';
import { Card, Col, Row, CardHeader, CardBody } from 'reactstrap';
import CustomSelect from '../../../../Components/Common/CustomSelect'
import { getCreativesForPublish } from '../../../../slices/publish/thunk';
import adform from '../../../../assets/images/publish/adform.png';
import { goBack, push } from 'redux-first-history';
import { bytesToKB } from '../../../../slices/helper';
import { getAdformAdvertisers, getAdformCredential } from '../../../../slices/publish/adform/thunk';
import AdformCredentialModal from './AdformCredentialModal';
import { setCurrentVersion } from '../../../../slices/campaigns/reducer';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");

function Adform() {
  const dispatch = useDispatch();
  const location = useLocation();
  const selectStates = createSelector(state => state, state => ({
    versions: state.Campaign.versions,
    creativesForPublish: state.Publish.creativesForPublish,
    selectedCreativesPublish: state.Publish.selectedCreativesPublish,
    adformPublishSettings: state.Publish.adformPublishSettings,
    adformCredentialAsked: state.Publish.adformCredentialAsked,
    selectedPublishTagId: state.Publish.selectedPublishTagId,
    scriptPublishTag: state.Publish.scriptPublishTag
  }));
  const { versions, creativesForPublish, selectedCreativesPublish, adformPublishSettings, adformCredentialAsked, selectedPublishTagId, scriptPublishTag } = useSelector(selectStates);
  const [versionState, setVersionState] = useState([]);
  const [scriptState, setScriptState] = useState([]);

  useEffect(() => {
    (async () => {
      if (adformCredentialAsked === false) {
        dispatch(setAdformCredentialAsked(true));
        dispatch(setPublishLoader(true));
        await dispatch(getAdformCredential());
        dispatch(setPublishLoader(false));
      }
    })()
  }, [location]);

  useEffect(() => {
    if (Array.isArray(versions) && versions.length > 0) {
      setVersionState([
        { value: 'All', name: 'All Versions' },
        ...versions.map(item => { return { value: item._id, name: item.name } })
      ]);
      dispatch(setCurrentVersion(versions[0]));
    }
  }, [versions]);

  function handleVersionChange(version) {
    if (version && version?.value) {
      const foundVersion = versions.find(item => item._id === version.value);
      dispatch(setCurrentVersion(foundVersion));
      dispatch(getCreativesForPublish(version));  
    }
  }

  useEffect(() => {
    if (creativesForPublish === null) {
      handleVersionChange(versionState[1]);
    }
  }, [versionState, creativesForPublish]);

  const tableRef = useRef();
  useEffect(() => {
    if (creativesForPublish) {
      try {
        const table = $(tableRef.current).DataTable({
          data: creativesForPublish,
          columns: [
            {
              data: null,
              title: '#',
              orderable: false,
              render: () => {
                return "<input type='checkbox' class='form-check-input' />"
              }
            },
            {
              data: null,
              title: 'Version',
              render: (data, type, row) => {
                const foundVersion = versions.find(item => item._id === row.versionId);
                if (foundVersion) {
                  return foundVersion.name;
                }
              }
            },
            {
              data: null,
              title: 'Size',
              render: (data, type, row) => {
                return `<p class='m-0'>${row.size}</p>`
              }
            },
            {
              data: null,
              title: 'Publish Status',
              render: (data, type, row) => {
                if (row?.published === true) {
                  return `<span class="badge bg-success-subtle text-primary fs-11 text-uppercase">
                          <i class="ri-checkbox-circle-line align-bottom"></i> Published
                        </span>`
                } else {
                  return `<span class="badge bg-danger text-white fs-11 text-uppercase">
                              <i class="ri-close-circle-line align-bottom"></i> Not Published
                          </span>`
                }
              }
            },
            {
              data: null,
              title: 'Banner Weight',
              render: (data, type, row) => {
                return bytesToKB(row.fileSize);
              }
            },
            // {
            //   data: null,
            //   title: '',
            //   render: (data, type, row) => {
            //     return `<button class='btn btn-info btn-icon btn-sm'>
            //       <i class='ri-eye-fill'></i>
            //     </button>`
            //   }
            // }
          ],
          responsive: true,
          responsive: {
            details: {
              renderer: $.fn.dataTable.Responsive.renderer.listHiddenNodes()
            }
          },
          columnDefs: [
            { responsivePriority: 1, targets: [1, -2] },
            { responsivePriority: 2, targets: "_all" },
          ],
          language: {},
          destroy: true,
          searching: false,
          paging: false,
          info: false,
        });

        table.on('click', 'tr', function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            if ($(this).hasClass("selected-row")) {
              $(this).removeClass("selected-row");
              $(this).find(".form-check-input").prop("checked", false);
              dispatch(removeCreativeForPublish(data));
            } else {
              $(this).addClass("selected-row");
              $(this).find(".form-check-input").prop("checked", true);
              dispatch(selectCreativeForPublish(data));
            }
          }
        });

        return function () {
          table.destroy();
        };
      } catch (error) {
        // console.log(error);
      }
    }
  }, [creativesForPublish, adformPublishSettings]);

  async function handleSelect() {
    dispatch(setPublishLoader(true));
    // await dispatch(getDcmAdvertisers());
    // dispatch(setDcmPublishSettings(true));
    await dispatch(getAdformAdvertisers());
    dispatch(setAdformPublishSettings(true));
    dispatch(setPublishLoader(false));
  }

  function handleGoBack() {
    dispatch(goBack());
  }
  return (
    <React.Fragment>
      {adformPublishSettings ?
        <AdformSettings />
        :
        <React.Fragment>
          <Row>
            <Col>
              <Card>
                <div className='w-100 p-3 d-flex align-items-center justify-content-between'>
                  <div className='d-flex align-items-center'>
                    <button className='btn btn-light btn-icon fw-bold' onClick={handleGoBack}>
                      <i className='ri-arrow-left-line'></i>
                    </button>
                    <CustomSelect
                      tag='button'
                      className='ms-2 btn btn-light dropdown-toggle'
                      placeholder='Select Versions'
                      options={versionState}
                      onChange={(version) => handleVersionChange(version)}
                      value={(versionState[1]?.name || '')}
                    />
                    <CustomSelect
                      tag='button'
                      className='ms-2 btn btn-light dropdown-toggle'
                      placeholder='Select Publish Tag'
                      options={scriptState}
                      onChange={(script) => handleScriptChange(script)}
                      value={(scriptState[0]?.name || '')}
                    />
                  </div>
                  <div className='d-flex align-items-center justify-content-end'>
                    <img src={adform} className='w-auto me-4' style={{ height: '30px' }} draggable='false' />
                    {selectedCreativesPublish.length > 0 ?
                      <button className='btn btn-info' onClick={handleSelect}>
                        Select {selectedCreativesPublish.length} Creatives
                      </button>
                      : null}
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
          {creativesForPublish ?
            <Row>
              <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                <Card>
                  <CardHeader>
                    Select which banners you want to publish
                  </CardHeader>
                  <CardBody>
                    <div className='table-responsive table-card mt-0 pt-2'>
                      <table
                        className="align-middle table-nowrap mb-0 table"
                        style={{ width: "100%" }}
                        ref={tableRef}
                      >
                        <thead className="table-light"></thead>
                        <tbody></tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null}
        </React.Fragment>
      }
      <AdformCredentialModal />
    </React.Fragment>
  )
}

export default Adform
